import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { LoadingButton } from '@mui/lab';
import { FC } from 'react';
import { PartySuggestions } from 'react-dadata';
import 'react-dadata/dist/react-dadata.css';
import { useFormContext } from 'react-hook-form';

import { API_KEY } from '../../../config/api.config';

import styles from './UpdateOrg.module.sass';
import { useUpdateOrg } from './useUpdateOrg';

//Модальное окно "Добавить Организацию"
const UpdateOrg: FC = () => {
  //Изменить пользователя для организации
  const {
    onSubmit,
    handleChange,
    value,
    isValue,
    handleCloseModal,
    onClearValue,
    isLoading,
  } = useUpdateOrg();
  return (
    <div className={styles.wrapper}>
      <h2 className={styles.title}>Добавление организации</h2>
      <div className={styles.close} onClick={handleCloseModal}>
        <CloseRoundedIcon />
      </div>
      <div className={styles.error}>
        {isValue && <p>Проверьте введенные данные организации</p>}
      </div>

      <div className={styles.fields}>
        {isValue ? (
          <>
            <div className={styles.name}>
              <p> {value?.name?.short || value?.org_name}</p>
              <CloseRoundedIcon
                className={styles.close}
                onClick={onClearValue}
              />
            </div>
            <div className={styles.inn}>
              <p>ИНН {value?.inn}</p>
            </div>
            <div className={styles.ogrn}>
              <p>ОГРН {value?.ogrn || value.kpp}</p>
            </div>
            <div className={styles.address}>
              <p>
                {value?.address?.value || value?.legal_address},
                {value?.address?.data?.postal_code}
              </p>
            </div>
          </>
        ) : (
          <PartySuggestions
            token={API_KEY}
            count={30}
            // @ts-ignore
            value={value}
            onChange={handleChange}
            inputProps={{
              placeholder: 'Поиск по названию или ИНН компании',
            }}
          />
        )}
      </div>

      <LoadingButton
        loading={isLoading}
        loadingPosition="center"
        className={styles.button}
        onClick={onSubmit}
        variant="orange"
        fullWidth
      >
        Добавить
      </LoadingButton>
    </div>
  );
};

export default UpdateOrg;
